import classNames from 'classnames'
import Link from 'next/link'
import { Fragment, useCallback } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'

import CardHover from '@/components/CardHover/CardHover'
import { CardRef } from '@/types/card'
import useDirectories from '@/utils/useDirectories'

import CoolHeader from '../../CoolHeader/CoolHeader'

import styles from './TitlePanel.module.scss'

type Props = {
  flavorRefs?: CardRef[]
  header: string
  isPartner?: boolean
  oracleRef?: CardRef
}

const TitlePanel = ({ flavorRefs, header, isPartner, oracleRef }: Props) => {
  const { dir, subsubpage, subsubsubpage, subsubsubsubpage } = useDirectories()

  const flavorRefsSplit = isPartner ? 1 : 4
  const flavorRefsDisplay = flavorRefs?.slice(0, flavorRefsSplit)
  const shouldShowBottom = !!(flavorRefs || oracleRef)

  const flavorUrl = useCallback(
    (flavorName: string) =>
      `/${dir === 'deckpreview' ? 'commanders' : dir}/${flavorName}/${[subsubpage, subsubsubpage, subsubsubsubpage].filter((page) => !!page).join('/')}`,
    [dir, subsubpage, subsubsubpage, subsubsubsubpage],
  )

  return (
    <>
      <CoolHeader hasBottomSection={shouldShowBottom}>{header}</CoolHeader>
      {shouldShowBottom && (
        <div className={styles.altNamesContainer}>
          <div className={classNames(styles.altNames, 'shadow-sm')}>
            <p>
              <strong>{oracleRef ? 'Original Name:' : 'Alternate Names:'}</strong>
            </p>
            <div className={styles.altNamesList}>
              {oracleRef ? (
                <p>
                  <CardHover name={oracleRef.display_name} url={flavorUrl(oracleRef.slug)} />
                </p>
              ) : (
                <>
                  <p>
                    {flavorRefsDisplay &&
                      flavorRefsDisplay.map((flavorRef, index) => (
                        <Fragment key={flavorRef.slug}>
                          <>{!!index && <span>, </span>}</>
                          <CardHover name={flavorRef.display_name} url={flavorUrl(flavorRef.slug)} />
                        </Fragment>
                      ))}
                  </p>
                  {flavorRefs && flavorRefsDisplay && flavorRefs.length > flavorRefsDisplay.length && (
                    <Dropdown>
                      <Dropdown.Toggle className={styles.altNameMoreButton} size='sm' variant='secondary'>
                        More...
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {flavorRefs.slice(flavorRefsSplit).map((flavorRef) => (
                          <Dropdown.Item
                            as={Link}
                            href={`/${dir}/${flavorRef.slug}`}
                            key={flavorRef.slug}
                            scroll={false}
                          >
                            {flavorRef.display_name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default TitlePanel
